module.exports = __webpack_public_path__ + "img/landing08.b352413c.jpg";